import { render } from "./NewsEdit.vue?vue&type=template&id=139f5598"
import script from "./NewsEdit.vue?vue&type=script&lang=js"
export * from "./NewsEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__